export function throwIfAborted(signal: AbortSignal): void {
  if (typeof signal.throwIfAborted === 'function') {
    signal.throwIfAborted();
    return;
  }

  if (signal.aborted) {
    throw createAbortError();
  }
}

export function isAbortError(error: unknown): boolean {
  return error instanceof Error && error.name === 'AbortError';
}

function createAbortError(): Error {
  if (typeof DOMException === 'function') {
    return new DOMException('The operation was aborted.', 'AbortError');
  }

  const error = new Error('The operation was aborted.');
  error.name = 'AbortError';
  return error;
}
